import type { ReactNode } from 'react';
import { cn } from '@/app/utils';
import { openInNewTab, shouldOpenInNewTab } from '@/app/utils/client';

export type Item = {
  label: string | ReactNode;
  key: string;
  icon?: ReactNode;
  activeIcon?: ReactNode;
  inActiveIcon?: ReactNode;
};

interface NavsProps<NavItem> {
  navs: NavItem[];
  active?: string;
  className?: string;
  onChange: (nav: NavItem) => void;
  getHref?: (nav: NavItem) => string | undefined;
}

export const Navs = <NavItem extends Item>({ navs, active, className, onChange, getHref }: NavsProps<NavItem>) => {
  return (
    <div className={cn('hide-scrollbar flex items-center gap-5 overflow-x-scroll pr-6', className)}>
      {navs.map((it) => (
        <div
          key={it.key}
          className={cn(
            'relative flex flex-shrink-0 cursor-pointer flex-col pb-1 text-base text-system-white64 sm:text-sm',
            active === it.key &&
              'font-medium text-white before:absolute before:bottom-0 before:h-0.5 before:w-full before:rounded-full before:bg-white before:content-[""]',
          )}
          onClick={(e) => {
            if (shouldOpenInNewTab(e) && getHref) {
              const href = getHref(it);
              if (href) {
                openInNewTab(href);
                return;
              }
            }
            onChange(it);
          }}
        >
          <div className="flex items-center gap-1 px-0.5">
            <div>{it.label}</div>
            {active === it.key && (it.activeIcon || it.icon)}
            {active !== it.key && (it.inActiveIcon || it.icon)}
          </div>
        </div>
      ))}
    </div>
  );
};
